module.exports = __webpack_public_path__ + "static/media/47.7f46da5e.png";